export const EXCLUDED_PATH_SEGMENTS: readonly string[] = [
  '/library/application support/',
  '/library/caches/',
  '/library/preferences/',
  '/.local/share/',
  '/.cache/',
  'node_modules/',
  '.cargo/registry/',
  '.gradle/caches/',
  '.m2/repository/',
]

export function isExcludedProject(path: string): boolean {
  const normalizedPath = path.toLowerCase()
  return EXCLUDED_PATH_SEGMENTS.some((segment) => normalizedPath.includes(segment))
}
